<template>
  <span>
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[ { name: '面接情報', pathName: 'interviewInformationTop' }]"
        :title="`面接情報_${title}`"
      />
      <div v-if="!isEdit">
        <div
          class="align-justify"
          data-test="notification"
        >
          <p class="margin-bottom-0">ユーザーサイトに掲載する内容を登録します。</p>
          <p class="boss-text margin-top-0 margin-bottom-1">
            個人情報や誹謗中傷など公序良俗に反する内容は記載しないようご注意ください。トラブルが発生した場合、当社では一切責任を負いかねます。
          </p>
        </div>
      </div>
      <div>
        <div class="boss-scout-send-container">
          <form-item
            v-model="jobInterview.name"
            form-label-class-name="pega-form-label-importance"
            placeholder="(例)事務用（20XX年度版)"
          >
            <template #label>
              <span>登録名</span>
            </template>
            <template #header>
              <span>本画面内で管理に使う項目です。ユーザーサイトには表示されません。</span>
              <div>
                <small>{{ jobInterview.name.length }}文字/ 30文字</small>
              </div>
            </template>
            <template #error>
              <validation-label
                v-if="nameValidation.isShow"
                data-test="error-name"
                :label="nameValidation.message"
              />
            </template>
          </form-item>
          <div class="grid-x grid-padding-x grid-padding-y pega-form">
            <div
              class="medium-3 cell pega-form-label pega-form-label-importance"
              data-test="form-label"
            >
              <span>求人設定</span>
            </div>
            <div class="auto cell">
              <div
                v-if="publishedJobs.length === 0"
                data-test="no-published-jobs"
              >
                設定できる求人がありません。
              </div>
              <div v-else>
                <div class="pega-mb-05">
                  <span class="boss-text font-bold">公開する求人を選択してください。※未選択の場合は面接情報が公開されません。</span>
                </div>
                <div
                  v-for="(option, i) in publishedJobs"
                  :key="option.jobId"
                >
                  <label class="boss-checkbox">
                    <input
                      v-model="jobInterview.jobs"
                      type="checkbox"
                      class="boss-input-checkbox"
                      :checked="jobInterview.jobs.includes(option.jobId)"
                      :data-test="`option-jobs-${i}`"
                      :value="option.jobId"
                    >
                    <span :data-test="`option-job-label-${i}`">
                      {{ option.jobAdministrationName }}（ {{ option.jobName }} ）
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="boss-joboffer-title boss-setting margin-top-2"
        data-test="interview-information-title"
      >
        概要
      </div>
      <div>
        <div class="boss-scout-send-container">
          <form-item-radio-with-text-area
            v-model="jobInterview.paperScreening.id"
            :options="interviewOptions.paperScreenings"
            value-class-name="pega-badge-radio-text pega-badge-radio-check-mark"
            placeholder="（例） 合否に関らず、3営業日以内にメッセージにてご連絡いたします。"
            :max-character="300"
            :remarks.sync="jobInterview.paperScreeningRemarks"
            option-key-label="paper-sreenings"
          >
            <template #label>
              <span>書類選考の有無</span>
            </template>
            <template #error>
              <validation-label
                v-if="paperScreeningRemarksValidation.isShow"
                data-test="error-paper-sreenings"
                :label="paperScreeningRemarksValidation.message"
              />
            </template>
          </form-item-radio-with-text-area>
          <form-item-radio-with-text-area
            v-model="jobInterview.spiTest.id"
            :options="interviewOptions.spiTests"
            value-class-name="pega-badge-radio-text pega-badge-radio-check-mark"
            placeholder="(例）SPI検査（WEBテスト）を実施します。"
            :max-character="300"
            :remarks.sync="jobInterview.spiTestRemarks"
            option-key-label="spi-test"
          >
            <template #label>
              <span>適性検査の有無</span>
            </template>
            <template #error>
              <validation-label
                v-if="spiRemarksValidation.isShow"
                data-test="error-spi-test"
                :label="spiRemarksValidation.message"
              />
            </template>
          </form-item-radio-with-text-area>
          <form-item-text-area
            v-model="jobInterview.message"
            :placeholder="`（例） 弊社のビジョン「〇〇〇〇〇〇〇」に、共感していただける方からのご応募を、お待ちしております！\nご不安なことがありましたら、些細なことでもご相談下さい。`"
            class-name="pega-interview-textarea-large pega-textarea-low pega-textarea-vertical"
            data-test="message"
          >
            <template #label>
              <span>応募する方への<br>メッセージ</span>
            </template>
            <template #header>
              <div>
                <small>{{ jobInterview.message.length }}文字/ 800文字</small>
              </div>
            </template>
            <template #error>
              <validation-label
                v-if="messageValidation.isShow"
                data-test="error-message"
                :label="messageValidation.message"
              />
            </template>
          </form-item-text-area>
        </div>
      </div>
    </div>
    <div class="boss-main-wrap boss-main-content-wrap pega-interview-detail-background margin-top-2 padding-bottom-3">
      <div
        class="boss-joboffer-title boss-setting margin-top-1"
        data-test="interview-detail-title"
      >
        詳細
      </div>
      <div>
        <p class="boss-text margin-top-0 margin-bottom-1">応募者のみに表示されます。</p>
      </div>
      <div class="boss-scout-send-container boss-bgcolor-white margin-top-0">
        <div class="grid-x grid-padding-x  pega-form pega-interview-form">
          <div class="medium-3 cell  pega-pd-15  pega-interview-form-label">
            <span>面接の選考情報</span>
          </div>
          <div class="cell auto">
            <form-item-text-area
              ref="content"
              v-model="jobInterview.content"
              placeholder="（例）面接の流れ、チェックポイント、雰囲気など"
              class-name="pega-interview-textarea-large pega-textarea-low pega-textarea-vertical"
              form-label-class-name="pega-form-label-interview"
              data-test="content"
            >
              <template #label>
                <span>面接内容</span>
              </template>
              <template #header>
                <div class="boss-textarea-button">
                  <button
                    class="boss-button"
                    data-test="sample-text"
                    @click="insertionValue()"
                  >
                    例文を挿入する
                  </button>
                </div>
                <div>
                  <small>{{ jobInterview.content.length }}文字/ 500文字</small>
                </div>
              </template>
              <template #error>
                <validation-label
                  v-if="contentValidation.isShow"
                  data-test="error-content"
                  :label="contentValidation.message"
                />
              </template>
            </form-item-text-area>
            <div class="grid-x grid-padding-x grid-padding-y pega-form pega-interview-form-top-none">
              <div
                class="medium-3 cell pega-form-label pega-form-label-interview-top"
                data-test="form-label"
              >
                <span>面接官について</span>
              </div>
              <div class="auto cell padding-top-0 padding-left-0 padding-right-0 interview-form-top-none">
                <div
                  v-for="(interviewer, i) in jobInterview.interviewers"
                  :key="i"
                >
                  <interviewer
                    :selection-type.sync="interviewer.selectionType.id"
                    :interviewer="interviewer"
                    :index="i + 1"
                    :gender.sync="interviewer.gender.id"
                    :position.sync="interviewer.position.id"
                    :generation.sync="interviewer.generation.id"
                    :remarks-or-free-text.sync="interviewer.remarksOrFreeText"
                    @delete="deleteInterviewer(i)"
                  />
                </div>
                <button
                  v-if="isAbleToAddInterviewers()"
                  class="boss-button boss-button-new  margin-left-1 "
                  data-test="add-interviewer"
                  @click="addInterviewer()"
                >
                  <span class="boss-icon-new" />
                  <span class="boss-button-new-text">選考を追加する</span>
                </button>
              </div>
            </div>
            <form-item-radio-with-text-area
              v-model="jobInterview.requiredTime.id"
              :options="interviewOptions.requiredTimes"
              value-class-name="pega-badge-radio-text pega-badge-radio-check-mark"
              placeholder="（例）会社説明+面接のトータル時間となります。"
              :max-character="300"
              :remarks.sync="jobInterview.requiredTimeRemarks"
              option-key-label="required-time"
              :is-optional="true"
              form-label-class-name="pega-form-label-interview"
            >
              <template #label>
                <span>所要時間<small>（任意）</small></span>
              </template>
              <template #suffix>
                <span>程度</span>
              </template>
              <template #error>
                <validation-label
                  v-if="requiredTimeRemarksValidation.isShow"
                  data-test="error-required-time-remarks"
                  :label="requiredTimeRemarksValidation.message"
                />
              </template>
            </form-item-radio-with-text-area>
            <form-item-radio-with-text-area
              v-model="jobInterview.cloth.id"
              :options="interviewOptions.clothes"
              value-class-name="pega-badge-radio-text pega-badge-radio-check-mark"
              placeholder="（例）筆記用具のご用意をお願いいたします。"
              :max-character="300"
              :remarks.sync="jobInterview.clothRemarks"
              option-key-label="cloth"
              :is-optional="true"
              form-label-class-name="pega-form-label-interview"
              form-class-name="pega-interview-form-bottom-none"
            >
              <template #label>
                <span>面接時の服装／持ち物<small>（任意）</small></span>
              </template>
              <template #error>
                <validation-label
                  v-if="clothRemarksValidation.isShow"
                  data-test="error-cloth-remarks"
                  :label="clothRemarksValidation.message"
                />
              </template>
            </form-item-radio-with-text-area>
          </div>
        </div>

        <div class="grid-x grid-padding-x  pega-form pega-interview-form">
          <div class="medium-3 cell  pega-pd-15  pega-interview-form-label">
            <span>重視するポイント<br>
              <small>「★」が多いほど重視するポイントとなります。</small></span>
          </div>
          <div class="cell auto">
            <form-item-rating
              :rating.sync="jobInterview.businessManner"
              label="ビジネスマナー"
              form-label-class-name="pega-form-label-interview"
            />
            <form-item-rating
              :rating.sync="jobInterview.communicationAbility"
              label="コミュニケーション能力"
              form-label-class-name="pega-form-label-interview"
            />
            <form-item-rating
              :rating.sync="jobInterview.skill"
              label="過去の経験・スキル"
              form-label-class-name="pega-form-label-interview"
            />
            <form-item-rating
              :rating.sync="jobInterview.motivation"
              label="やる気"
              form-label-class-name="pega-form-label-interview"
              form-class-name="pega-interview-form-bottom-none"
            />
          </div>
        </div>

        <div class="grid-x grid-padding-x  pega-form pega-interview-form">
          <div class="medium-3 cell  pega-pd-15  pega-interview-form-label pega-interview-form-label-bottom">
            <span>中途面接について</span>
          </div>
          <div class="cell auto">
            <form-item-text-area
              v-model="jobInterview.question1"
              placeholder="（例）仕事をする上で重視していることは何ですか？"
              form-label-class-name="pega-form-label-interview"
              class-name="pega-textarea-low pega-textarea-vertical"
              data-test="question1"
            >
              <template #label>
                <span>過去の質問例１</span>
              </template>
              <template #header>
                <div>
                  <small>{{ jobInterview.question1.length }}文字/ 300文字</small>
                </div>
              </template>
              <template #error>
                <validation-label
                  v-if="question1Validation.isShow"
                  data-test="error-question1"
                  :label="question1Validation.message"
                />
              </template>
            </form-item-text-area>
            <form-item-text-area
              v-model="jobInterview.question2"
              placeholder="（例）5年後、10年後の自分はどうなっていたいですか？"
              form-label-class-name="pega-form-label-interview"
              class-name="pega-textarea-low pega-textarea-vertical"
              data-test="question2"
            >
              <template #label>
                <span>過去の質問例２<small>（任意）</small></span>
              </template>
              <template #header>
                <div>
                  <small>{{ jobInterview.question2 ? jobInterview.question2.length : 0 }}文字/ 300文字</small>
                </div>
              </template>
              <template #error>
                <validation-label
                  v-if="question2Validation.isShow"
                  data-test="error-question2"
                  :label="question2Validation.message"
                />
              </template>
            </form-item-text-area>
            <form-item-text-area
              v-model="jobInterview.question3"
              placeholder="（例）入社可能時期はいつですか？"
              :max-character="300"
              form-label-class-name="pega-form-label-interview"
              class-name="pega-textarea-low pega-textarea-vertical"
              data-test="question3"
            >
              <template #label>
                <span>過去の質問例３<small>（任意）</small></span>
              </template>
              <template #header>
                <div>
                  <small>{{ jobInterview.question3 ? jobInterview.question3.length : 0 }}文字/ 300文字</small>
                </div>
              </template>
              <template #error>
                <validation-label
                  v-if="question3Validation.isShow"
                  data-test="error-question3"
                  :label="question3Validation.message"
                />
              </template>
            </form-item-text-area>
            <interview-information-welcome-question
              v-model="jobInterview.welcomeQuestions"
              :options="interviewOptions.welcomeQuestionsOptions"
              form-label-class-name="pega-form-label-interview"
            >
              <template #label>
                <span>歓迎する質問<small>（任意）</small></span>
              </template>
              <template #header>
                <span>応募者からの質問で、面接時に回答可能な項目がありましたらチェックをお願いいたします。</span>
              </template>
            </interview-information-welcome-question>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-main-wrap boss-main-content-wrap">
      <!-- 登録確認ボタン▼ -->
      <form-button-area>
        <form-confirm-button
          :is-disabled="hasErrors"
          submit-label="登録内容を確認する"
          data-test="confirm-button"
          @submit-event="onConfirmClick"
        />
      </form-button-area>
      <!-- ▲登録確認ボタン -->
    </div>
  </span>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import FormItem from '@/components/atoms/FormItem'
import FormItemTextArea from '@/components/atoms/FormItemTextArea'
import { jobInterview } from '@/lib/labelValueMappings'
import FormItemRadioWithTextArea from '@/components/atoms/FormItemRadioWithTextArea'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import InterviewInformationWelcomeQuestion from '@/components/atoms/InterviewInformationWelcomeQuestion'
import FormItemRating from '@/components/atoms/FormItemRating'
import Interviewer from '@/components/molecules/Interviewer'

export default {
  components: {
    SettingHeader,
    FormButtonArea,
    FormConfirmButton,
    FormItem,
    FormItemTextArea,
    FormItemRadioWithTextArea,
    ValidationLabel,
    InterviewInformationWelcomeQuestion,
    FormItemRating,
    Interviewer
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    jobInterview: {
      type: Object,
      required: true
    },
    publishedJobs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      interviewOptions: jobInterview
    }
  },
  computed: {
    title () {
      return this.isEdit ? '編集' : '登録'
    },
    hasErrors () {
      return this.validated(this.nameValidation) || this.validated(this.paperScreeningRemarksValidation) || this.paperScreeningValidation ||
    this.spiValidation || this.validated(this.spiRemarksValidation) ||
    this.validated(this.messageValidation) || this.validated(this.contentValidation) || this.interviewersValidation() ||
    this.validated(this.requiredTimeRemarksValidation) || this.validated(this.clothRemarksValidation) || this.importancePointValidation ||
    this.validated(this.question1Validation) || this.validated(this.question2Validation) || this.validated(this.question3Validation)
    },
    nameValidation () {
      return this.requiredValidation(this.jobInterview.name) ||
      this.lengthValidation(this.jobInterview.name, 30)
    },
    paperScreeningRemarksValidation () {
      return this.lengthValidation(this.jobInterview.paperScreeningRemarks, 300)
    },
    paperScreeningValidation () {
      return this.jobInterview.paperScreening.id === 0
    },
    spiRemarksValidation () {
      return this.lengthValidation(this.jobInterview.spiTestRemarks, 300)
    },
    spiValidation () {
      return this.jobInterview.spiTest.id === 0
    },
    messageValidation () {
      return this.requiredValidation(this.jobInterview.message) ||
      this.lengthValidation(this.jobInterview.message, 800)
    },
    contentValidation () {
      return this.requiredValidation(this.jobInterview.content) ||
      this.lengthValidation(this.jobInterview.content, 500)
    },
    requiredTimeRemarksValidation () {
      return this.lengthValidation(this.jobInterview.requiredTimeRemarks, 300)
    },
    clothRemarksValidation () {
      return this.lengthValidation(this.jobInterview.clothRemarks, 300)
    },
    importancePointValidation () {
      return this.jobInterview.businessManner === 0 || this.jobInterview.communicationAbility === 0 ||
       this.jobInterview.skill === 0 || this.jobInterview.motivation === 0
    },
    question1Validation () {
      return this.requiredValidation(this.jobInterview.question1) ||
      this.lengthValidation(this.jobInterview.question1, 300)
    },
    question2Validation () {
      return this.lengthValidation(this.jobInterview.question2, 300)
    },
    question3Validation () {
      return this.lengthValidation(this.jobInterview.question3, 300)
    }
  },
  methods: {
    lengthValidation (target, val) {
      return {
        isShow: (target ? target.length > val : false),
        message: `${val}文字以内で入力してください`
      }
    },
    requiredValidation (target) {
      if (target === null || target === undefined || target.trim().length === 0) {
        return {
          isShow: true,
          message: '入力してください'
        }
      }
    },
    insertionValue () {
      const value = '面接では主に、前職での具体的な仕事内容や成果・得られた経験などをお聞きします。\nまた、志望動機や弊社に興味をもったポイントなどもお聞きする場面があるかもしれません。\nお互いを理解する場として和やかな雰囲気で行えればと思います。'
      const cursorPosition = this.$refs.content.getTextSelectionStart()
      this.$set(this.jobInterview, 'content', `${this.jobInterview.content.substr(0, cursorPosition)}${value}${this.jobInterview.content.substr(cursorPosition, this.jobInterview.content.length)}`)
    },
    createDefaultInterviewer (index) {
      return {
        no: index,
        selectionType: { id: 1, name: '' },
        gender: { id: 0, name: '' },
        position: { id: 0, name: '' },
        generation: { id: 0, name: '' },
        remarksOrFreeText: null
      }
    },
    addInterviewer () {
      const index = this.jobInterview.interviewers.length + 1
      if (this.jobInterview.interviewers.length < 10) {
        this.jobInterview.interviewers.push(this.createDefaultInterviewer(index))
      }
    },
    deleteInterviewer (index) {
      this.$dialog.confirm('この選考を削除します。よろしいですか。')
        // はいを押下した時
        .then(() => {
          // 削除処理追加
          this.removeInterviewer(index)
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    removeInterviewer (i) {
      if (this.jobInterview.interviewers.length === 1) {
        // １次選考は必須登録のため、リセットして初期値を返す
        this.jobInterview.interviewers.splice(0, 1, this.createDefaultInterviewer(1))
      } else {
        this.jobInterview.interviewers.splice(i, 1)
      }
    },
    isAbleToAddInterviewers () {
      return this.jobInterview.interviewers.length < 10
    },
    validated (val) {
      return val.isShow === true
    },
    interviewersValidation () {
      const targets = this.jobInterview.interviewers
      // 入力方法を選択していないデータがあれば、非活性
      if (targets.some(value => value.selectionType.id === 0)) return true
      // 備考欄またはフリーテキストが1000文字超過の場合、非活性
      if (targets.some(value => (value.remarksOrFreeText?.length ?? 0) > 1000)) return true
      // 入力方法がフリー項目でテキスト未入力の場合、非活性
      if (targets.some(value => value.selectionType.id === 2 &&
      (value.remarksOrFreeText === null || (value.remarksOrFreeText?.trim().length ?? 0) === 0))) return true
      // 入力方法が選択肢で選択肢が未設定の場合、非活性
      if (targets.some(value => value.selectionType.id === 1 &&
      (value.gender.id === 0 || value.position.id === 0 || value.generation.id === 0))) return true

      return false
    },
    onConfirmClick () {
      this.$emit('filledOut')
    }
  }
}
</script>
